/**
 * A global namespace for `gesturestart` event.
 */
const gesturestartEvent = 'gesturestart';
export default gesturestartEvent;
